export interface Atlas {
  tiles: Record<string, HTMLImageElement>;
  sprites: Record<string, HTMLImageElement>;
  icons: Record<string, HTMLImageElement>;
  ui: Record<string, HTMLImageElement>;
  title: HTMLImageElement | null;
  ready: boolean;
}

const TILE_FILES: Record<string, string> = {
  grass: "/assets/tiles/grass.png",
  dirt: "/assets/tiles/dirt.png",
  path: "/assets/tiles/path.png",
  water: "/assets/tiles/water.png",
  wood: "/assets/tiles/wood.png",
  hollow: "/assets/tiles/hollow.png",
  soil: "/assets/tiles/dirt.png",
};

const SPRITE_FILES: Record<string, string> = {
  player: "/assets/sprites/player.png",
  mara: "/assets/sprites/mara.png",
  cal: "/assets/sprites/cal.png",
  pike: "/assets/sprites/pike.png",
  lurcher: "/assets/sprites/lurcher.png",
  listener: "/assets/sprites/listener.png",
  skitter: "/assets/sprites/skitter.png",
  watcher: "/assets/sprites/watcher.png",
  well: "/assets/sprites/well.png",
  house: "/assets/sprites/house.png",
};

const ICON_FILES: Record<string, string> = {
  ration: "/assets/icons/ration.png",
  seed_root: "/assets/icons/seed.png",
  seed_bitter: "/assets/icons/seed.png",
  herb: "/assets/icons/herb.png",
  scrap: "/assets/icons/scrap.png",
  cinder: "/assets/icons/cinder.png",
  rope: "/assets/icons/rope.png",
  lantern_oil: "/assets/icons/oil.png",
  bandage: "/assets/icons/bandage.png",
  artifact: "/assets/icons/artifact.png",
  note: "/assets/icons/note.png",
  strange_root: "/assets/icons/herb.png",
  survey_plate: "/assets/icons/artifact.png",
};

const UI_FILES: Record<string, string> = {
  panel: "/assets/ui/panel.png",
  slot: "/assets/ui/slot.png",
  bar: "/assets/ui/bar.png",
};

function loadImg(src: string): Promise<HTMLImageElement | null> {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null);
    img.src = src;
  });
}

async function group(files: Record<string, string>): Promise<Record<string, HTMLImageElement>> {
  const out: Record<string, HTMLImageElement> = {};
  await Promise.all(
    Object.entries(files).map(async ([k, src]) => {
      const img = await loadImg(src);
      if (img) out[k] = img;
    }),
  );
  return out;
}

export async function loadAtlas(): Promise<Atlas> {
  const [tiles, sprites, icons, ui, title] = await Promise.all([
    group(TILE_FILES),
    group(SPRITE_FILES),
    group(ICON_FILES),
    group(UI_FILES),
    loadImg("/assets/title.jpg"),
  ]);
  return { tiles, sprites, icons, ui, title, ready: true };
}
